// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button_3RtIV","small":"Button_small_1JaAN","transparent":"Button_transparent_2ry7a","grayscale":"Button_grayscale_1R_Uy","back":"Button_back_38P1-"};